define('GameDayCore/GDModel/load/flow/PregameHeartbeatFlow',['require','exports','module','../../enums/datasources/Datasources','./HeartbeatFlow'],function(require,exports,module){
    var Datasources = require("../../enums/datasources/Datasources"),
        HeartbeatFlow = require( "./HeartbeatFlow" );

    var Superclass;

    function PregameHeartbeatFlow(worker){
        Superclass.constructor.call(this,worker,this.complete,Datasources.LINESCORE);
    }

    HeartbeatFlow.spawn(PregameHeartbeatFlow).define({

    });

    Superclass = PregameHeartbeatFlow.superclass;
    return PregameHeartbeatFlow;
});
